import $ from 'jquery';
import slick from 'slick-carousel';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui';

class Testimonial {
    constructor(target, settings) {
        this.carouselContainer = target;
        this.settings = settings || {
            accesibility: false,
            mobileFirst: true,
            arrows: false,
            dots: true,
            centermode: false,
            infinite: true,
            adaptiveHeight: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        arrows: true,
                        dots: true,
                        adaptiveHeight: true
                    }
                }
            ]
        };
    }

    init() {
        $(this.carouselContainer).slick(this.settings);
		this.initTestimonials();
        this.calculateSlideNumber();
    }

    calculateSlideNumber() {
        // Selects all slides that are not cloned, then the ones that have images, and then again the slides to get only the ones that are shown vissually
        const slides = $('.slick-slide:not(.slick-cloned)').find('.lifestyle-career-item-img').closest('.slick-slide');
        const slidesNumber = slides.length;
        
        slides.each((index) => {
            $(this).attr('aria-label', `slide ${index + 1} of ${slidesNumber}`);
        });
    }

    initTestimonials() {
        // Testimonial carousel
        if ($('.testimonial').length) {
            $('.testimonial').slick({
                accesibility: false,
                arrows: true,
                dots: true,
                infinite: true,
                adaptiveHeight: true
            });
            $('ul.slick-dots').removeAttr('role');
            $('ul.slick-dots li').removeAttr('role');
            $('ul.slick-dots button').removeAttr('tabindex');
            $('ul.slick-dots button').removeAttr('aria-controls');
            $('ul.slick-dots button').removeAttr('role');
            $('.slick-arrow').append('<span aria-hidden="true"></span>');
            $('.slick-slide').attr('role', 'group');
            $('.slick-slider').attr('role', 'region');
            $('.slick-slider').attr('aria-label', 'carousel');

            $('.testimonial').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
                if ($('.slick-dots li button')[currentSlide] === document.activeElement) {
                    $($('.slick-dots li button')[nextSlide]).focus();
                }
            });
            $('.testimonial').on('afterChange', (event, slick, currentSlide, nextSlide) => {
                setTimeout(() => {
                    $('ul.slick-dots').removeAttr('role');
                    $('ul.slick-dots li').removeAttr('role');
                    $('ul.slick-dots button').removeAttr('tabindex');
                    $('ul.slick-dots button').removeAttr('aria-controls');
                    $('ul.slick-dots button').removeAttr('role');
                    $('.slick-slide').attr('role', 'group');
                    $('.slick-slide').attr('aria-label', 'slide');
                    $('.slick-slider').attr('role', 'region');
                    $('.slick-slider').attr('aria-label', 'carousel');
                }, 300);   
            });
        }
        //---/ End Testimonial carousel

        //Testimonial Career Carousel
        if ($('.testimonial-career').length) {
            $('.testimonial-career').slick({
                accesibility: false,
                arrows: true,
                dots: true,
                infinite: true,
                adaptiveHeight: true
            });
            $('ul.slick-dots').removeAttr('role');
            $('ul.slick-dots li').removeAttr('role');
            $('ul.slick-dots button').removeAttr('tabindex');
            $('ul.slick-dots button').removeAttr('aria-controls');
            $('ul.slick-dots button').removeAttr('role');
            $('.slick-slide').attr('role', 'group');
            $('.slick-arrow').append('<span aria-hidden="true"></span>');
            $('.testimonial-career-item-img').append('<span aria-hidden="true"></span>');
            $('.slick-slider').attr('role', 'region');
            $('.slick-slider').attr('aria-label', 'carousel');

            $('.testimonial-career').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
                if ($('.slick-dots li button')[currentSlide] === document.activeElement) {
                    $($('.slick-dots li button')[nextSlide]).focus();
                }
            });
            $('.testimonial-career').on('afterChange', (event, slick, currentSlide, nextSlide) => {
                setTimeout(() => {
                    $('ul.slick-dots').removeAttr('role');
                    $('ul.slick-dots li').removeAttr('role');
                    $('ul.slick-dots button').removeAttr('tabindex');
                    $('ul.slick-dots button').removeAttr('aria-controls');
                    $('ul.slick-dots button').removeAttr('role');
                    $('.slick-slide').attr('role', 'group');
                    $('.slick-slide').attr('aria-label', 'slide');
                    $('.slick-slider').attr('role', 'region');
                    $('.slick-slider').attr('aria-label', 'carousel');
                }, 300);   
            });
        }

        if ($('.lifestyle-career').length) {
            $('.lifestyle-career').slick({
                accesibility: false,
                arrows: true,
                dots: true,
                infinite: true,
                adaptiveHeight: true
            });
            $('ul.slick-dots').removeAttr('role');
            $('ul.slick-dots li').removeAttr('role');
            $('ul.slick-dots button').removeAttr('tabindex');
            $('ul.slick-dots button').removeAttr('aria-controls');
            $('ul.slick-dots button').removeAttr('role');
            $('.slick-slide').attr('role', 'group');
            $('.slick-slider').attr('role', 'region');
            $('.slick-slider').attr('aria-label', 'carousel');

            $('.lifestyle-career').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
                if ($('.slick-dots li button')[currentSlide] === document.activeElement) {
                    $($('.slick-dots li button')[nextSlide]).focus(); 
                }
            });
            $('.lifestyle-career').on('afterChange', (event, slick, currentSlide, nextSlide) => {
                setTimeout(() => {
                    $('ul.slick-dots').removeAttr('role');
                    $('ul.slick-dots li').removeAttr('role');
                    $('ul.slick-dots button').removeAttr('tabindex');
                    $('ul.slick-dots button').removeAttr('aria-controls');
                    $('ul.slick-dots button').removeAttr('role');
                    $('.slick-slide').attr('role', 'group');
                    $('.slick-slide').attr('aria-label', 'slide');
                    $('.slick-slider').attr('role', 'region');
                    $('.slick-slider').attr('aria-label', 'carousel');
                }, 300);   
            });
        }
    }
}

export default Testimonial;

$(() => {
	const testimonial = new Testimonial();
	testimonial.init();
});